import { useContext } from "react";
import Mustache from "mustache";
import { OrganizationProvider } from "@/features/websites/components/OrganizationProvider";
import { WebsiteContext } from "@/pages/website/WebsiteProvider";
import { useEditor } from "@craftjs/core";
import { SectionContext } from "../blocks/section-block/SectionBlock";
import { useParams } from "react-router-dom";

const context = {
  year: new Date().getFullYear(),
};

const useVariableValues = (forceParsing?: boolean) => {
  const { query } = useEditor();
  const organization = useContext(OrganizationProvider);
  const website = useContext(WebsiteContext);
  const section = useContext(SectionContext);
  const { organizationAlias } = useParams<{ organizationAlias?: string }>();

  const getValue = (value: string | number) => {
    const isEditorEnabled = query.getOptions().enabled;
    if (!value || !organization || !section || (!forceParsing && isEditorEnabled)) return value;

    try {
      const output = Mustache.render(value.toString(), {
        ...context,
        ...organization,
        ...section,
        ...website.organization,
        organizationAlias,
      });
      return output;
    } catch (error) {
      console.error(error);
    }

    return;
  };

  return {
    getValue,
  };
};

export default useVariableValues;
